import React from "react";
import LoginStepComponent from "./components/login.component";
import { useCreateEquismobileContext } from "./provider/createEquismobile.provider";
import Code2FAStepComponent from "./components/code.component";
import CreateNewsEquismobileComponent from "./news/create.news.component";
import CreateUserEquismobileComponent from "./used/create.used.component";
import { useCreateNewsEquismobileContext } from "./news/provider/createNewsEquismobile.provider";
import { useCreateUsedEquismobileContext } from "./used/provider/createUsedEquismobile.provider";
import SelectFlowComponent from "./components/select-flow.component";
import RecoverStep from "./components/recover.component";
import CreateSimplyComponent from "./simply/create-simply.component";

const CreateEquismobileComponent = () => {
  const { flow, step } = useCreateEquismobileContext();
  const { step: stepNews } = useCreateNewsEquismobileContext();
  const { step: stepUsed } = useCreateUsedEquismobileContext();

  return (
    <>
      {step < 5 ? (
        <div
          className={`mx-auto w-11/12 md:w-2/3 lg:px-10 ${step !== 3 && "rounded-xl bg-white py-5 shadow-xl"}`}
        >
          <div className="mx-auto w-5/6 overflow-hidden pt-10 lg:w-3/4">
            {step === 1 && <LoginStepComponent />}
            {step === 2 && <Code2FAStepComponent />}
            {step === 3 && <SelectFlowComponent />}
            {step === 4 && <RecoverStep />}
          </div>
        </div>
      ) : (
        <>
          <div
            className={`flex w-full md:mt-20 md:flex-col lg:mt-20 xl:mt-20 xl:flex-row 2xl:mt-0 ${stepUsed === 3 && "md:mt-96 lg:mt-96 xl:mt-80"} ${stepNews === 2 && "md:mt-96 lg:mt-96 xl:mt-80"}`}
          >
            <div className="w-full rounded-xl bg-white py-5 shadow-xl md:-mt-1 lg:px-10 xl:mt-10">
              <div className="mx-auto w-5/6 overflow-hidden pt-10 lg:w-3/4">
                <CreateSimplyComponent />
                {/*   {flow === "new" && <CreateNewsEquismobileComponent />}
                {flow === "used" && <CreateUserEquismobileComponent />} */}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
export default CreateEquismobileComponent;
